import { Plus } from "lucide-react";
import { useMemo } from "react";
import { CreateTaskModal } from "~/components/admin/dispatch/task";
import { CompleteTaskModal } from "~/components/common/complete-task/complete-task-modal";
import { GetTaskParams, useGetTasks } from "~/services/task";
import { TaskFilters } from "./filter-tasks";
import { TableTasks } from "./table-tasks";
import { useTaskStore } from "./task.store";

export const ListTasks = () => {
  const { openTaskModal, filters } = useTaskStore();

  const filterParams = useMemo<GetTaskParams>(() => {
    const params: GetTaskParams = {
      page: filters.page,
      pageSize: filters.pageSize,
      search: filters.search,
    };

    if (filters.status !== "all") {
      params.status = filters.status;
    }

    if (filters.dueDate) {
      params.dueDate = filters.dueDate.toISOString();
    }

    return params;
  }, [filters]);

  const { data: tasks, isLoading } = useGetTasks(filterParams);

  return (
    <div className="bg-gray-50">
      <CreateTaskModal />
      <CompleteTaskModal />

      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-semibold">Internal Events & Tasks</h1>
        <div className="flex space-x-4">
          <button
            onClick={() => openTaskModal()}
            className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 shadow-sm"
          >
            <Plus size={16} />
            <span>New Task</span>
          </button>
        </div>
      </div>

      <TaskFilters />

      {/* Task List View */}
      <div className="bg-white rounded-lg border shadow-sm">
        <div className="p-4 border-b">
          <div className="flex justify-between items-center">
            <h2 className="font-medium">Tasks & Events</h2>
            <div className="text-sm text-gray-500">
              {tasks?.meta.totalItems} item{tasks?.meta.totalItems ? "s" : ""} found
            </div>
          </div>
        </div>

        <TableTasks tasks={tasks} isLoading={isLoading} />
      </div>
    </div>
  );
};
